export class LieuImmobilisation {
  id: number;
  lieu: string;
  constructor(id: number, lieu: string) {
    this.id = id;
    this.lieu = lieu;
  }
}
